<template>
  <div class="datePicker">
    <div v-if="isPhone">
      <van-field
        readonly
        clickable
        name="calendar"
        :value="form.date1"
        label=""
        placeholder="点击选择日期"
        @click="showCalendar = true"
      />
      <van-calendar
        v-model="showCalendar"
        :min-date="minDate"
        @confirm="onConfirm"
      />
    </div>

    <el-date-picker
      v-else
      type="date"
      placeholder="选择日期"
      v-model="form.date1"
      style="width: 100%;"
      :picker-options="{
        disabledDate,
      }"
      value-format="yyyy-MM-dd"
      @change="change"
    ></el-date-picker>
  </div>
</template>

<script>
import mixins from "./mixins";
import { isPhone } from "@/utils/utils";
import moment from "moment";
import workService from "@/apis/work/index.js";

export default {
  name: "datePicker",
  mixins: [mixins],
  data() {
    return {
      showCalendar: false,
      form: {},
      isPhone: isPhone(),
      minDate: new Date("2000-01-01"),
    };
  },
  created() {
    this.initMinDate();
  },

  methods: {
    disabledDate(currentDate) {
      return moment(currentDate).isBefore(this.minDate, "date");
    },
    initMinDate() {
      const { question } = this;
      if (question.datasource) {
        workService.getStartDate({}, question.datasource).then((data) => {
          this.minDate = new Date(data);
        });
      }
    },
    onConfirm(date) {
      this.form.date1 = moment(date).format("YYYY-MM-DD");
      this.showCalendar = false;
      this.change(this.form.date1);
    },
  },
};
</script>

<style lang="scss" scoped>
.van-cell {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>